module.exports = __webpack_public_path__ + "img/norfolk-island.cd496e08.svg";